<mat-toolbar color="accent">Assign Step: {{ data.step.title }}</mat-toolbar>

<mat-dialog-content>
  <form [formGroup]="form">
    <pr-staff-selector
      label="Assign Step To"
      formControlName="assignee"
      [practice]="data.practice"
    />

    <mat-form-field class="w-full">
      <mat-label>Due date</mat-label>
      <input
        matInput
        formControlName="dueDate"
        [matDatepicker]="picker"
        [min]="minDate"
        (click)="picker.open()"
      />
      <mat-datepicker-toggle matSuffix [for]="picker" />
      <mat-datepicker #picker />
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <pt-buttons-container padding="none">
    <button mat-stroked-button mat-dialog-close>Cancel</button>
    <button
      mat-flat-button
      color="primary"
      [disabled]="form.invalid"
      (click)="save()"
    >
      Assign
    </button>
  </pt-buttons-container>
</mat-dialog-actions>
